import { useState } from "react";
import { Button, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import ProductsService from "../../../services/ProductsService";

const Products = () => {
	const [products, setProducts] = useState([]);
	const [hasData, setHasData] = useState(0);
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [indexEdit, setIndexEdit] = useState(null);
	const [isDeleted, setIsDeleted] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const navigate = useNavigate();
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const productsService = new ProductsService();
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	return (
		<>
			<Card className="mb-3">
				<Card.Body className="d-flex justify-content-between align-items-center p-3 ">
					<div className="input-group w-50">
						<input
							type="text"
							style={{
								borderRadius: "8px",
								color: "initial",
								padding: "18px 33px 18px 16px",
							}}
							className="form-control"
							placeholder={`${Translate[lang]?.search_by} ${Translate[lang]?.name}`}
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<div
							className="flaticon-381-search-2"
							style={{
								position: "absolute",
								zIndex: "1",
								right: lang === "en" && "16px",
								left: lang === "ar" && "16px",
								top: "50%",
								transform: "translate(0, -50%)",
							}}></div>
					</div>
					{isExist("add_products") && (
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => navigate("/products/add-products")}>
							<i
								className={`la la-plus ${lang === "en" ? "mr-2" : "ml-2"}`}></i>
							{Translate[lang]?.add} {Translate[lang]?.products}
						</Button>
					)}
				</Card.Body>
			</Card>

			<div className="d-flex mb-3" style={{ gap: "12px" }}>
				<Button
					variant={isDeleted ? "secondary" : "primary"}
					onClick={() => setIsDeleted(false)}>
					{Translate[lang]?.active}
				</Button>
				<Button
					variant={!isDeleted ? "secondary" : "primary"}
					onClick={() => setIsDeleted(true)}>
					{Translate[lang]?.not_active}
				</Button>
			</div>

			<Card>
				<Card.Body className={`${hasData === 0 && "text-center"} `}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>{Translate[lang]?.image}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.category}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.price}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.amount}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.actions}</strong>
									</th>
								</tr>
							</thead>
							<tbody>
								{products?.map((item, index) => {
									return (
										<CardItem
											key={index}
											index={index}
											item={item}
											setShouldUpdate={setShouldUpdate}
											setIndexEdit={setIndexEdit}
											indexEdit={indexEdit}
										/>
									);
								})}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setProducts}
						service={productsService}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						isDeleted={isDeleted}
						setLoading={setLoading}
						search={search}
						type={"normal"}
					/>
				</Card.Body>
			</Card>
		</>
	);
};
export default Products;
